import {createContext, useContext, useEffect, useState} from "react";
import baseUrl from "../baseUrl";
import {useAuthContext} from "./AuthContext";
import {requester} from "../services/requester";

export const AppContext = createContext();

export const AppProvider = ({children}) => {
    const {isAuthenticated} = useAuthContext();
    const [settlements, setSettlements] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [companiesBullstat, setCompaniesBullstat] = useState([]);
    const [settlementsEkatte, setSettlementsEkatte] = useState([]);
    const [user, setUser] = useState({});
    const [years, setYears] = useState([]);
    const request = requester();

    useEffect(() => {
        if (isAuthenticated) {
            Promise.all([
                request.get(`${baseUrl()}/part-settlements`),
                request.get(`${baseUrl()}/companies`),
                request.get(`${baseUrl()}/user`),
                request.get(`${baseUrl()}/years`)
            ])

                .then(([dataSettlements, dataCompanies, dataUser, dataYears]) => {
                    setSettlements(dataSettlements);
                    setCompanies(dataCompanies);
                    setUser(dataUser);
                    setYears(Array.isArray(dataYears) ? dataYears : []);

                    const companies_bullstat = [];
                    dataCompanies.forEach(company => {
                        companies_bullstat.push(company.bullstat);
                    })
                    setCompaniesBullstat(companies_bullstat);

                    const settlements_ekatte = [];
                    dataSettlements.forEach(settlement => {
                        settlements_ekatte.push(settlement.ekatte);
                    })
                    setSettlementsEkatte(settlements_ekatte);
                })
        }
    }, [isAuthenticated])

    const onNewCompanySubmit = () => {
        request.get(`${baseUrl()}/companies`)
            .then((data) => {
                setCompanies(data);
            })
    }

    // let companies_bullstat = [];
    // for (let i = 0; i < Object.keys(companies).length; i++) {
    //     companies_bullstat.push(companies[i].bullstat)
    // }

    const contextValues = {
        settlements,
        companies,
        companiesBullstat,
        settlementsEkatte,
        user,
        years,
        onNewCompanySubmit
    }

    return (
        <AppContext.Provider value={contextValues}>
            {children}
        </AppContext.Provider>
    );
};

export const useAppContext = () => {
    return useContext(AppContext);
};